<template>
  <div>
    <div class="container_top_img">
      <img src="../../assets/img/new/researchBanner.png" alt="logo" :onerror="defaultImg">
    </div>
    <div class="my_container">
      <div class="glag_all">
        <div class="research_top_nav">
          <dl v-for="(item, index) in researchList"
          :key="item.id"
          :class="item.research_id === parseInt(researchId) ? 'research_top_nav_item act' : 'research_top_nav_item'"
          @click="researchJump(item.research_id, index)">
            <dt>
              <i></i>
              <span>{{item.research_name}}</span>
            </dt>
            <dd>{{item.research_en_name}}</dd>
          </dl>
        </div>
      </div>
      <!-- 研究院简介 -->
      <div class="glag_all">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>联盟简介</span>
          </p>
        </div>
        <div class="glag_calss_introduce">
          <div class="glag_calss_introduce_left">
            <img :src="researchContent.bg_img" alt="研究院封面" :onerror="defaultImg">
          </div>
          <div class="glag_calss_introduce_right">
            <dl>
              <dt>{{researchContent.research_name}}</dt>
              <dd>{{researchContent.research_en_name}}</dd>
            </dl>
            <div class="glag_calss_introduce_text">{{researchContent.content}}</div>
          </div>
        </div>
      </div>
      <!-- 组织架构 -->
      <div class="glag_all">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>组织架构</span>
            <router-link class="rt" :to="{ path: '/researchIntroduce', query: {id: researchId, type: 'organizational'} }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
        </div>
        <div class="glag_calss_organization">
         <!-- <div class="glag_calss_organization_left">
           <span>组织架构</span>
           <a class="my_icon_list more_icon_circle"></a>
         </div> -->
         <div class="glag_calss_organization_right">
          <dl v-for="n in researchFramework" :key="n.id">
            <dt>
              <img :src="n.user_avatar" alt="用户头像" :onerror="defaultImg">
            </dt>
            <dd>
              <p>{{n.user_name}}</p>
              <b>{{n.framework_name}}</b>
            </dd>
          </dl>
         </div>
        </div>
      </div>
      <!-- 国际交流 -->
      <div class="glag_half lf">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>国际交流</span>
            <router-link class="rt" :to="{ path: '/internationalList', query: {id: researchId} }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
          <el-divider></el-divider>
        </div>
        <div class="research_exchange_box">
          <div v-for="item in internationalList" :key="item.id" class="research_exchange_item">
            <div class="research_exchange_top">
              <div v-if="item.img !== ''" class="research_exchange_img">
                <img :src="item.img" alt="封面" :onerror="defaultImg">
              </div>
              <div class="research_exchange_content" :class="item.img === '' ? 'padding_left_0' : ''">
                <div class="research_exchange_title" @click="jump(item.list_id, 24)">
                  {{item.title}}
                </div>
                <div class="research_exchange_text" v-html="item.content"></div>
              </div>
            </div>
            <div class="research_exchange_bottom">
               <div class="research_exchange_time lf">
                 {{item.add_time}}
               </div>
               <div class="research_exchange_other rt">
                 <el-breadcrumb separator="|">
                   <el-breadcrumb-item class="my_icon_box"><a><i class="my_icon dianzan"></i><span class="my_icon_text">{{item.post_like}}</span></a></el-breadcrumb-item>
                   <el-breadcrumb-item class="my_icon_box"><a><i class="my_icon pinglun"></i><span class="my_icon_text">{{item.comment_count}}</span></a></el-breadcrumb-item>
                   <el-breadcrumb-item class="my_icon_box r_border"><a><i class="my_icon shoucang"></i><span class="my_icon_text">{{item.favorites}}</span></a></el-breadcrumb-item>
                   <el-breadcrumb-item></el-breadcrumb-item>
                 </el-breadcrumb>
               </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 项目合作 -->
      <div class="glag_half rt">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>项目合作</span>
            <router-link class="rt" :to="{ path: '/objectList', query: {id: researchId} }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
          <el-divider></el-divider>
        </div>
        <div class="research_cooperation_box">
          <div v-for="item in projectList" :key="item.id" class="research_cooperation_item lf">
            <p class="research_cooperation_img">
              <img :src="item.portrait" alt="头像">
            </p>
            <div class="research_cooperation_content">
              <p class="research_cooperation_name">
                {{item.user_name}}
              </p>
              <p class="research_cooperation_text" v-html="item.content"  @click="jump(item.list_id, 26)"></p>
            </div>
            <div class="research_cooperation_bottom">
              <span class="my_icon_box"><a><i class="my_icon dianzan"></i><span class="my_icon_text">{{item.post_like}}</span></a></span>
              <el-divider direction="vertical"></el-divider>
              <span class="my_icon_box"><a><i class="my_icon pinglun"></i><span class="my_icon_text">{{item.comment_count}}</span></a></span>
              <el-divider direction="vertical"></el-divider>
              <span class="my_icon_box"><a><i class="my_icon shoucang"></i><span class="my_icon_text">{{item.favorites}}</span></a></span>
            </div>
          </div>
        </div>
      </div>
      <!-- 广告位 -->
      <div class="glag_all m_t_30">
        <img class="community_banner" src="../../assets/img/research/banner.jpg" alt="">
      </div>
      <!-- 研究成果/行业手册/报告下载 -->
      <div class="glag_half lf">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span class="comment_btn" :class="navTop === '研究成果' ? 'act' : ''" @click="sortBtn('研究成果')">研究成果</span>
            <span class="comment_btn" :class="navTop === '行业手册' ? 'act' : ''" @click="sortBtn('行业手册')">行业手册</span>
            <span class="comment_btn" :class="navTop === '课题报告' ? 'act' : ''" @click="sortBtn('课题报告')">课题报告</span>
            <a class="rt" @click.prevent="findJump(navTop)" >MORE <u class="iconfont icon-gengduo"></u></a>
            <el-divider></el-divider>
          </p>
        </div>
        <div class="research_down_box">
          <div v-for="(item, index) in findingsList" :key="item.id" class="research_down_item">
            <div v-if="index === 0" class="research_down_left first_label lf">{{index + 1}}</div>
            <div v-if="index === 1" class="research_down_left two_label lf">{{index + 1}}</div>
            <div v-if="index === 2" class="research_down_left three_label lf">{{index + 1}}</div>
            <div v-if="index > 2" class="research_down_left glay_label lf">{{index + 1}}</div>
            <div class="research_down_title lf">
              <p @click="jump(item.list_id, findingsListPage.nav_id)">{{item.title}}</p>
            </div>
            <div class="research_down_other lf">
              <p class="lf">
                <span>{{item.read}}</span>
                人浏览
              </p>
              <el-divider direction="vertical" class="lf"></el-divider>
              <p class="lf">
                <span>{{item.download}}</span>
                人下载
              </p>
            </div>
            <div v-if="item.more.length > 0" class="research_down_btn my_icon_box rt">
              <button class="greenglga_btn" @click="downDialog(index, item.list_id)">
                <i class="xiazai"></i>
                <span>下载</span>
              </button>
            </div>
            <div v-else class="research_down_btn my_icon_box rt">
              <button class="greenglga_btn greenglga_btn_cancle" disabled="true">
                无文件
              </button>
            </div>
          </div>
        </div>
        <el-dialog title="下载列表" width="600px" :visible.sync="downDialogOnOff">
          <el-table :data="downDialogList">
            <el-table-column :show-overflow-tooltip="true" property="name" label="文件名" width="500"></el-table-column>
            <el-table-column label='操作' width="70">
              <template slot-scope="scope">
                <el-link :href="scope.row.path">下载</el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-dialog>
      </div>
      <!-- 出版物 -->
      <div class="glag_half research_book_box rt">
        <div class="title_top_hr">
          <p>
            <span>出版物</span>
            <router-link class="rt" :to="{ path: '/bookList', query: { id: researchId } }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
            <el-divider></el-divider>
          </p>
        </div>
        <div class="research_book_swiper">
          <el-carousel trigger="click" indicator-position="none" arrow="always" height="253">
            <el-carousel-item v-for="(item) in bookList" :key="item.id">
              <div class="my_book_swiper_item">
                <div class="my_book_swiper_left">
                  <img :src="item.book_img" :onerror="defaultImg">
                </div>
                <div class="my_book_swiper_right">
                  <div class="my_book_swiper_title" >
                    <a @click.prevent="jump(item.list_id, 29)">{{item.title}}</a>
                  </div>
                  <div class="my_book_swiper_name">
                    作者：{{item.author}}
                  </div>
                  <div class="my_book_swiper_text">
                    <span v-if="item.content.length > 49">{{item.content | strFilter}}</span>
                    <span v-else-if="item.content.length < 50">{{item.content}}</span>
                    <span v-else>书籍暂无简介</span>
                    <a @click="jump(item.list_id, 29)">[详情]</a>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
     <!-- 学术交流 -->
      <div class="glag_half lf">
       <div class="title_top_hr">
         <p>
           <span>学术交流</span>
           <router-link class="rt" :to="{ path: '/learningList', query: {id: researchId} }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
         </p>
         <el-divider></el-divider>
       </div>
       <div class="research_learning_box">
         <div v-for="item in learningList" :key="item.id" class="research_learning_item">
           <div v-if="item.img !== ''" class="research_learning_left">
             <img :src="item.img" alt="封面">
           </div>
           <div class="research_learning_right" :class="item.img === '' ? 'padding_left_0' : ''">
             <div class="research_learning_info">
               <img :src="item.portrait" alt="头像">
               <span>{{item.user_name}}</span>
               <span>{{item.add_time}}</span>
             </div>
             <div class="research_learning_title" @click="jump(item.list_id, 23)">
               {{item.title}}
             </div>
              <div class="research_learning_text" v-html="item.content"></div>
           </div>
         </div>
       </div>
     </div>
     <!-- 专家学者 -->
      <!-- <div class="glag_half rt">
        <div class="title_top_hr">
          <p>
            <span>专家学者</span>
            <router-link class="rt" :to="{ name: 'ScholarList' }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
          <el-divider></el-divider>
        </div>
        <div class="research_contact_box">
          <div v-for="(item) in 4" :key="item.id" class="research_contact_item lf">
            <div class="research_contact_left">
              <img src="../../assets/img/authentication/lawterReview.png" alt="头像">
            </div>
            <div class="research_contact_right">
              <div class="research_contact_name">
                <a @click="userJump(item.user_id)">
                  张三
                </a>
              </div>
              <div class="research_contact_text">
                <p class="research_contact_research_name">所属研究院：{{item.research_name}}</p>
                <p class="research_contact_framework_name">职务：{{item.framework_name}}</p>
              </div>
            </div>
            <div class="research_contact_bottom">
              <p>
                <i>1324</i>
                人关注
              </p>
              <button class="greenglga_btn">
                <i class="add">+</i>
                <span>关注</span>
              </button>
            </div>
          </div>
        </div>
      </div> -->
     <!-- 生活部落 -->
      <div class="glag_half rt">
        <div class="title_top_hr">
          <p>
            <span>生活部落</span>
            <router-link class="rt" :to="{ path: '/circleList', query: { type: 'research', id: researchId } }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
          <el-divider></el-divider>
        </div>
        <div class="research_life_box">
          <div v-for="item in boardList" :key="item.id" class="research_life_item lf">
            <div class="research_life_left">
              <p><img :src="item.pic" alt="封面"></p>
              <button v-if="item.is_join === 0" class="greenglga_btn">加入</button>
              <button v-if="item.is_join === 1" class="greenglga_btn greenglga_btn_cancle" disabled="disabled">已加入</button>
            </div>
            <div class="research_life_right">
              <p class="research_life_title" @click="circleJump(item.id)">{{item.name}}</p>
              <p class="research_life_text">{{item.synopsis}}</p>
              <p class="research_life_other">
                <span>成员{{item.numbers}}</span>
                <el-divider direction="vertical"></el-divider>
                <span>帖子{{item.post_count}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      defaultImg: 'this.src="' + require('../../assets/img/other/imgError.png') + '"',
      hoverIndex: '', // 入驻企业鼠标移入记录下标
      researchId: '', // 研究院id
      researchList: [], // 研究学院列表
      researchContent: {}, // 研究院简介
      researchFramework: [], // 组织架构
      internationalList: [], // 国际交流列表
      projectList: [], // 项目合作列表
      navTop: '研究成果',
      // 研究成果、报告下载、行业手册列表
      findingsLoading: true,
      findingsList: [],
      findingsListPage: {
        limit: 6,
        page: 1,
        sort: 1,
        nav_id: '22', // 默认为研究成果
        research_id: '' // 研究院id
      },
      bookList: [], // 出版物列表
      // 下载列表弹窗开关
      downDialogOnOff: false,
      // 下载列表数据
      downDialogList: [],
      // 学术交流列表
      learningList: [],
      boardList: [] // 生活部落列表
    }
  },
  filters: {
    strFilter: function (value) {
      let str = ''
      if (value.length > 49) {
        str = value.substr(0, 49) + '...'
      } else {
        str = value
      }
      return str
    }
  },
  created () {
    this.researchId = this.$route.query.id
    this.getResearchIndex(this.researchId)
  },
  watch: {
    $route () {
      this.researchContent = {}
      this.researchFramework = []
      this.internationalList = []
      this.projectList = []
      this.navTop = '研究成果'
      this.findingsLoading = true
      this.findingsList = []
      this.bookList = []
      this.downDialogOnOff = false
      this.downDialogList = []
      this.learningList = []
      this.boardList = []
      this.getResearchIndex(this.researchId)
    }
  },
  methods: {
    // 获取研究院数据
    getResearchIndex (researchId) {
      const vueThat = this
      vueThat.myApi.getResearchIndex({ research_id: researchId }).then((res) => {
        if (res.data.code === 200) {
          vueThat.researchList = res.data.data.research_list
          vueThat.researchContent = res.data.data.content
          vueThat.researchFramework = res.data.data.research_framework
          vueThat.internationalList = res.data.data.international
          vueThat.projectList = res.data.data.project
          vueThat.learningList = res.data.data.learning
          vueThat.bookList = res.data.data.book_list
          vueThat.findingsList = res.data.data.achievements
          vueThat.boardList = res.data.data.board
        }
      })
    },
    // 研究院导航跳转
    researchJump (researchId, index) {
      if (this.researchList[index].is_join !== 1) {
        this.$message({
          type: 'error',
          message: '您还未加入该研究院'
        })
      } else {
        if (researchId !== this.researchId) {
          this.$router.push({ path: '/research/:id', query: { id: researchId } })
          this.researchId = researchId
        }
      }
    },
    // 行业手册、课题报告、研究成果 切换
    sortBtn (name) {
      this.navTop = name
      this.findingsListPage.research_id = this.researchId
      switch (name) {
        case '课题报告':
          this.findingsListPage.nav_id = 20
          break
        case '行业手册':
          this.findingsListPage.nav_id = 21
          break
        case '研究成果':
          this.findingsListPage.nav_id = 22
          break
      }
      this.getResearchFindingsList(this.findingsListPage)
    },
    // 行业手册、报告下载、研究成果 跳转
    findJump (name) {
      let url = ''
      switch (name) {
        case '研究成果':
          url = '/findingsList'
          break
        case '行业手册':
          url = '/industryList'
          break
        case '课题报告':
          url = '/reportList'
          break
      }
      this.findingsLoading = false
      this.$router.push({ path: url, query: { id: this.researchId } })
    },
    // 获取行业手册、报告下载、研究成果列表
    async getResearchFindingsList (data) {
      const vueThat = this
      await vueThat.myApi.getResearchFindingsList(data).then((res) => {
        if (res.data.code === 200) {
          vueThat.findingsLoading = false
          vueThat.findingsList = res.data.data
        }
      })
    },
    // 下载列表
    downDialog (index, rid) {
      this.downDialogOnOff = true
      this.downDialogList = this.findingsList[index].more
      if (this.downDialogList.length > 0) {
        this.downloadItem(rid)
      }
    },
    // 下载监控
    downloadItem (id) {
      const vueThat = this
      vueThat.myApi.addDownload({ list_id: id }).then((res) => {
      })
    },
    // 点击跳转详情
    jump (listId, navId, isDoing) {
      console.log(listId)
      console.log(navId)
      this.mycommon.detailJump(this, listId, navId, isDoing)
    },
    // 圈子跳转
    circleJump (rid) {
      const routeData = this.$router.resolve({
        path: '/cirlePostList/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    },
    // 个人中心页面跳转
    userJump (rid) {
      const routeData = this.$router.resolve({
        path: '/personalCenter/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped="scoped">
  .container_top_img{
    width: 100%;
    min-width: 1100px;
    height: auto;
    margin-top: -30px;
    margin-bottom: 30px;
  }
</style>
